import { FC, memo, ReactElement } from 'react'
import { Box, IconButton, IconButtonProps } from '@chakra-ui/react'

type Props = IconButtonProps & {
  amount?: number
  icon: ReactElement
}

const IconButtonWithBadge: FC<Props> = ({ icon, amount, ...props }) => {
  if (!amount || amount == 0) return <IconButton icon={icon} {...props} />

  return (
    <IconButton
      {...props}
      icon={
        <>
          {icon}

          {amount ? (
            <Box
              as="span"
              pos="absolute"
              top="3px"
              right="3px"
              px={2}
              py={1}
              fontSize="xs"
              fontWeight="bold"
              lineHeight="none"
              color="red.100"
              transform="translate(50%,-50%)"
              bg="red.600"
              rounded="full"
            >
              {amount}
            </Box>
          ) : (
            <Box
              as="span"
              pos="absolute"
              top="-3px"
              right="-3px"
              p="4px"
              fontSize="xs"
              fontWeight="bold"
              lineHeight="none"
              bg="red.600"
              rounded="full"
            />
          )}
        </>
      }
    />
  )
}

export default memo(IconButtonWithBadge)
